export default "__VITE_ASSET__Ctyn$1f7__"